export default __webpack_public_path__ + "static/Hero-About-2eab5d6e06d2e01b995585d40ca31ce5.jpg";